<template>
  <div
    :class="[`backdrop ${isOpenCreateCategoriesBlock ? 'show-backdrop' : ''}`]"
    @click="setCloseCreatedWindow"
  >
    <div
      :class="[
        `payment-info-block ${
          isOpenCreateCategoriesBlock ? 'open-payment-info-block' : ''
        }`,
      ]"
      @click.stop=""
    >
      <div class="create-payment-header-container">
        <div>
          <h2 class="create-payment-title">
            {{
              isEditCategories
                ? $t("category.editCategory")
                : $t("category.createCategory")
            }}
          </h2>
        </div>
        <button
          class="create-bayment-close-button"
          @click="setCloseCreatedWindow"
        >
          <x-icon class="create-payment-close-icon" />
        </button>
      </div>
      <div></div>
      <div class="main-create-category-inputs-container">
        <div class="create-category-image-main-block">
          <div
            class="create-category-image-block"
            @click="setIsShowCategoriesImage"
          >
            <img
              v-if="isUsedIcon"
              :src="isUsedIcon"
              alt=""
              class="create-category-image"
            />
            <question-mark-icon v-else class="create-category-image" />
            <div class="create-category-edit-image-block">
              <edit-2-icon class="create-category-edit-image" />
            </div>
          </div>
        </div>
        <tab-input
          :title="$t('homePage.nameCategory')"
          :isCategoryName="true"
          :placeholder="$t('homePage.inputCategoryName')"
          :value="categoryName"
          @custom-input-val="saveCustomCategoryName"
        />
        <p class="error-message" v-if="isRequiredInput && !categoryName">
          {{ $t("category.requiredInput") }}
        </p>
        <p class="error-message" v-if="isSameName && categoryName">
          {{ $t("category.categoryExist") }}
        </p>
      </div>
      <div v-if="isShowCategoriesImage" class="all-categories-icons">
        <p class="select-categories-icons">{{ $t("category.chooseIcon") }}</p>
        <vue-perfect-scrollbar class="new-icons-scroll">
          <div class="categories-icons-container">
            <div
              v-for="icon of operationsCategories"
              :key="icon.id"
              @click="setChangeUsedIcon(icon.img)"
              class="selected-icon-block"
            >
              <img :src="icon.img" alt="" class="selected-icon" />
            </div>
          </div>
        </vue-perfect-scrollbar>
      </div>
      <p class="error-message-icons" v-if="isRequiredInput && !isUsedIcon">
        {{ $t("category.iconIsRequired") }}
      </p>
      <div
        v-if="!editCategoriesObject.is_default && isEditCategories"
        class="button-edit-container"
      >
        <button
          class="close-info-customer-modal delete"
          name="button"
          @click="deleteNewCategory"
        >
          {{ $t("homePage.deleteOperation") }}
        </button>
        <button
          class="close-info-customer-modal"
          name="button"
          @click="createNewCategory"
        >
          {{ isEditCategories ? $t("category.edit") : $t("category.create") }}
        </button>
      </div>
      <button
        v-else
        class="close-info-customer-modal"
        name="button"
        @click="createNewCategory"
      >
        {{ isEditCategories ? $t("category.edit") : $t("category.create") }}
      </button>
    </div>
  </div>
</template>

<script>
import {
  XIcon,
  // ActivityIcon,
  // AwardIcon,
  // BellIcon,
  // BoxIcon,
  // CalendarIcon,
  Edit2Icon,
} from "vue-feather-icons";
import TabInput from "../../../components/TabInput.vue";
import QuestionMarkIcon from "../icons/QuestionMarkIcon.vue";
import { mapMutations } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { onVibrate } from "../../../helpers/utils";

export default {
  name: "Create-categories-block",
  components: {
    XIcon,
    // ActivityIcon,
    // AwardIcon,
    // BellIcon,
    // BoxIcon,
    // CalendarIcon,
    Edit2Icon,
    QuestionMarkIcon,
    TabInput,
    VuePerfectScrollbar,
  },
  props: {
    isOpenCreateCategoriesBlock: {
      type: Boolean,
      require: true,
    },
    activeType: {
      type: Object,
      require: true,
    },
    isEditCategories: {
      type: Boolean,
      require: true,
    },
    editCategoriesObject: {
      type: Object,
      require: false,
    },
  },
  data() {
    return {
      categoryValue: null,
      typeValue: null,
      categoryName: "",
      isKeyboardOpen: false,
      isShowCategoriesImage: true,
      isRequiredInput: false,
      isShowDrawsIndex: 0,
      isSameName: false,
      events: [],
      isShowError: false,
      isUsedIcon: "",
    };
  },
  async mounted() {},

  methods: {
    ...mapMutations([]),
    checkListValueType(value) {
      this.typeValue = value;
      if (!this.isEdit) {
        this.saveCreatedInfo({
          ...this.createdInfo,
          types: value,
        });
      }
    },
    setIsShowCategoriesImage() {
      onVibrate("click");
      this.isShowCategoriesImage = !this.isShowCategoriesImage;
    },
    setCloseCreatedWindow() {
      this.$emit("on-backdrop-click");
      setTimeout(() => {
        this.categoryName = "";
        this.isUsedIcon = "";
      }, 500);
    },
    deleteNewCategory() {
      this.$store.dispatch("setDeleteCategory", this.editCategoriesObject.id);
      this.setCloseCreatedWindow();
      this.isRequiredInput = false;
      this.isSameName = false;
      this.categoryName = "";
      this.isUsedIcon = "";
    },
    createNewCategory() {
      if (!this.categoryName || !this.isUsedIcon) {
        this.isRequiredInput = true;
        return;
      }
      let type = this.typeOperations.find(
        (el) => el.slug === this.activeType.slug
      );
      let data = {
        title: this.categoryName,
        type_id: type.id.toString(),
        img: this.isUsedIcon,
        account_id: this.currentCustomer.id.toString(),
      };

      let sameResult = this.setFindSameCategories(data);
      if (sameResult) {
        this.isSameName = sameResult;
        return;
      }
      if (this.isEditCategories) {
        data.id = this.editCategoriesObject.id;
        // this.$emit('is-save-new-category', data, true)
        this.$store.dispatch("setEditCategory", data);
      } else {
        this.$store.dispatch("setCreateNewCategory", JSON.stringify(data));
        // this.$emit('is-save-new-category', data)
      }
      this.setCloseCreatedWindow();
      this.isRequiredInput = false;
      this.isSameName = false;
      this.categoryName = "";
      this.isUsedIcon = "";
    },
    saveCustomCategoryName(value) {
      this.categoryName = value;
    },
    setChangeUsedIcon(value) {
      onVibrate("click");
      this.isUsedIcon = value;
    },
    setFindSameCategories(value) {
      if (value.type_id == 1) {
        let same = this.incomeCategories.some((el) => el.title === value.title);
        return same;
      } else if (value.type_id == 2) {
        let same = this.costCategories.some((el) => el.title === value.title);
        return same;
      } else if (value.type_id == 3) {
        let same = this.otherCategories.some((el) => el.title === value.title);
        return same;
      }
    },
  },
  computed: {
    incomeCategories() {
      return this.$store.getters.incomeCategories;
    },
    costCategories() {
      return this.$store.getters.costCategories;
    },
    otherCategories() {
      return this.$store.getters.otherCategories;
    },
    operationsCategories() {
      return this.$store.getters.operationsCategories;
    },
    currentCustomer() {
      return this.$store.getters.currentCustomer;
    },
    typeOperations() {
      return this.$store.getters.typeOperations;
    },
  },
  watch: {
    isOpenCreateCategoriesBlock(newVal, oldVal) {
      if (newVal && this.isEditCategories) {
        this.categoryName = this.editCategoriesObject.title;
        this.isUsedIcon = this.editCategoriesObject.img;
      }
      let val = oldVal;
      val;
    },
    categoryName() {
      onVibrate("click");
    },
  },
};
</script>

<style scoped>
.payment-info-block {
  position: absolute;
  width: 95%;
  height: 95%;
  left: 2.5%;
  bottom: 2.5%;
  padding: 15px;
  padding-top: 80px;
  transform: translateY(110%);
  pointer-events: all !important;
  -webkit-backdrop-filter: saturate(180%) blur(80px);
  backdrop-filter: saturate(180%) blur(80px);
  background-color: rgba(255, 255, 255, 0.8);
  pointer-events: none;
  overflow: hidden;
  z-index: 1000 !important;
  border: 0px !important;
  border-radius: 20px;
  transition: all 0.5s ease;
}

.open-payment-info-block {
  transform: none;
}

.create-payment-header-container {
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.create-payment-title {
  font-size: 24px;
  line-height: 30px;
  font-weight: 700;
  color: #1b1b1b;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: -0.6px;
  margin-bottom: 0px;
}

.create-bayment-close-button {
  cursor: pointer;
  background: transparent;
  border: none;
}

.create-payment-close-icon {
  width: 26px;
  height: 26px;
  color: #d84558;
}

.change-status-payments-block {
  background-color: rgba(0, 0, 0, 0.07);
  overflow: hidden;
  display: flex;
  padding: 5px;
  border-radius: 20px;
  margin: 10px 0 10px 0;
}

.status-button {
  transition: all 200ms ease;
  text-align: center;
  width: 100%;
  margin: auto;
  color: #000;
  line-height: 35px;
  font-size: 13px;
  background-size: cover;
  position: relative;
  z-index: 10;
  overflow: visible;
  background-color: transparent;
  transition: all 0.5s ease;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 600;
}

.status-button:hover {
  background: #00000016;
}

.status-button.active {
  background-image: var(--main-bg-color);
  color: #fff !important;
}

.error-message {
  font-size: 9px;
  line-height: 8px;
  color: red;
  font-weight: 600;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: 0.1px;
  margin-top: -5px;
  text-align: end;
}

.error-message-icons {
  font-size: 9px;
  line-height: 8px;
  color: red;
  font-weight: 600;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: 0.1px;
  margin-top: 10px;
  text-align: end;
}

.close-info-customer-modal {
  display: block;
  font-family: "Source Sans 3", sans-serif;
  text-transform: uppercase;
  position: relative;
  font-weight: 700;
  border-radius: 12px;
  font-size: 13px;
  padding: 14px 20px;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.1);
  transition: all 120ms ease;
  background-size: cover;
  z-index: 10;
  background-image: var(--main-bg-color);
  color: #fff;
  width: 90%;
  border: none;
  margin: 20px auto 0 auto;
  cursor: pointer;
}

.close-info-customer-modal.delete {
  background: #d84558;
}

.close-info-customer-modal::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.8) translateY(5px) translateZ(0px);
  filter: blur(12px);
}

.button-edit-container {
  display: flex;
  gap: 10px;
}

.create-category-image-main-block {
  display: flex;
  justify-content: center;
}

.create-category-image-block {
  position: relative;
  width: 50px;
  height: 50px;
  background-image: var(--main-bg-color);
  border-radius: 50%;
  background: #6eaeff45;
  display: flex;
  z-index: 10;
  margin-top: 20px;
  margin-bottom: 10px;
  cursor: pointer;
}

.create-category-image {
  margin: auto;
  color: #000;
  width: 25px;
}

.create-category-edit-image-block {
  position: absolute;
  display: flex;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #5d9cec;
}

.create-category-edit-image {
  width: 10px;
  height: 10px;
  color: #fff;
  margin: auto;
}

.categories-icons-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  margin-top: 10px;
}

.selected-icon-block {
  text-align: center;
  display: flex;
  cursor: pointer;
  width: 50px;
  height: 50px;
  margin: 0 auto;
  border-radius: 50%;
  background: #6eaeff45;
}

.selected-icon {
  margin: auto;
  color: #000;
  width: 25px;
}

.select-categories-icons {
  font-family: "Source Sans 3", sans-serif;
  color: #1b1b1b;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  margin-bottom: 0px;
  margin-left: 2px;
}

.new-icons-scroll {
  width: 100%;
  max-height: 40vh;
}
</style>
